/* Cellform — collection & search filtering via the Section Rendering API. URL is kept in sync (back button restores state). */
(() => {
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.cache = new Map();
      this.addEventListener('change', (e) => {
        if (e.target.closest('[data-facets-form]') || e.target.matches('[data-sort]')) {
          clearTimeout(this.t);
          this.t = setTimeout(() => this.onChange(), e.target.type === 'number' ? 600 : 50);
        }
      });
      this.addEventListener('submit', (e) => { if (e.target.closest('[data-facets-form]')) { e.preventDefault(); this.onChange(); } });
      this.addEventListener('click', (e) => {
        const remove = e.target.closest('[data-facet-remove], [data-facets-clear]');
        if (remove) { e.preventDefault(); this.render(new URL(remove.href, location.origin).search.slice(1)); return; }
        if (e.target.closest('[data-facets-open]')) this.openDrawer(e.target.closest('[data-facets-open]'));
        if (e.target.closest('[data-facets-close]')) this.closeDrawer();
      });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.querySelector('.facets.is-open')) this.closeDrawer(); });
      window.addEventListener('popstate', (e) => {
        const search = e.state && typeof e.state.search === 'string' ? e.state.search : location.search.slice(1);
        this.render(search, false);
      });
    }
    params() {
      const form = this.querySelector('[data-facets-form]');
      const fd = form ? new FormData(form) : new FormData();
      const sort = this.querySelector('[data-sort]');
      if (sort && !fd.has('sort_by')) fd.append('sort_by', sort.value);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (v !== '') params.append(k, v);
      return params.toString();
    }
    onChange() { this.render(this.params()); }
    async render(search, push = true) {
      const grid = this.querySelector(`#ProductGridContainer-${this.section}`);
      if (grid) grid.style.opacity = '.5';
      const url = `${location.pathname}?${search}${search ? '&' : ''}section_id=${this.section}`;
      let html = this.cache.get(url);
      try {
        if (!html) { html = await fetch(url).then((r) => r.text()); this.cache.set(url, html); }
      } catch (e) { if (grid) grid.style.opacity = ''; return; }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const openIds = [...this.querySelectorAll('.facet[open]')].map((d) => d.id);
      const focusId = document.activeElement && document.activeElement.id;
      ['ProductGridContainer', 'ActiveFacets', 'ResultsCount'].forEach((p) => {
        const cur = document.getElementById(`${p}-${this.section}`);
        const next = doc.getElementById(`${p}-${this.section}`);
        if (cur && next) cur.replaceWith(next);
      });
      const curForm = this.querySelector('[data-facets-form]');
      const nextForm = doc.querySelector(`#FacetsForm-${this.section}`);
      if (curForm && nextForm) {
        curForm.replaceWith(nextForm);
        nextForm.querySelectorAll('.facet').forEach((d) => { d.open = openIds.includes(d.id); });
      }
      const curFooter = this.querySelector('.facets__footer');
      const nextFooter = doc.querySelector(`#Facets-${this.section} .facets__footer`);
      if (curFooter && nextFooter) curFooter.replaceWith(nextFooter);
      if (focusId) { const f = document.getElementById(focusId); if (f) f.focus({ preventScroll: true }); }
      if (push) history.pushState({ search }, '', `${location.pathname}${search ? `?${search}` : ''}`);
      const count = document.getElementById(`ResultsCount-${this.section}`);
      if (count) window.Cellform.announce(count.textContent);
    }
    openDrawer(btn) {
      const facets = this.querySelector('.facets');
      if (!facets) return;
      this.opener = btn;
      facets.classList.add('is-open');
      facets.setAttribute('aria-modal', 'true');
      btn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
      window.Cellform.trapFocus(facets.querySelector('.facets__panel'));
    }
    closeDrawer() {
      const facets = this.querySelector('.facets');
      if (!facets || !facets.classList.contains('is-open')) return;
      facets.classList.remove('is-open');
      facets.setAttribute('aria-modal', 'false');
      document.body.classList.remove('overflow-hidden');
      if (this.opener) this.opener.setAttribute('aria-expanded', 'false');
      window.Cellform.removeTrapFocus(this.opener);
    }
  }
  if (!customElements.get('facet-filters')) customElements.define('facet-filters', FacetFilters);
})();
